// extracted by mini-css-extract-plugin
module.exports = {"menu":"Navbar_admin_menu__j5inE"};